import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconCapitalLetterH = SvgIcon({
    children: jsx("path", { d: "M13.32 7.6V11.044H9.72V7.6H8.34V16H9.72V12.364H13.32V16H14.7V7.6H13.32Z" }),
});

export { IconCapitalLetterH };
